import React from "react";
import icons from "./index";

const Icon = ({ name, ...props }) => {
  const SelectedIcon = icons[name];

  if (!SelectedIcon) {
    console.warn(`Ícone "${name}" não encontrado.`);
    return null;
  }

  return <SelectedIcon {...props} />;
};

export default Icon;
